import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-180a3d6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-item" }, " Please specify Download Options ", -1))
const _hoisted_2 = { class: "contract-aproval-popup-flex" }
const _hoisted_3 = { class: "top-content" }
const _hoisted_4 = { class: "contract-aproval-popup-flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-bottom":"0.4rem"} }, "Select Owner:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = ["disabled"]

import { computed, ref } from "vue";
import "@vuepic/vue-datepicker/dist/main.css";
import Popup from "@/components/Popup.vue" 
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import useNotifierWithErrFormatter from '@/services/composables/NotifierWithErrFormatter';
import DbTableCsvHelper from '@/services/helpers/DbTableCsvHelper';
import { contractApprovalExport } from  '@/services/network/index'
import IContractApproval from "@/Interfaces/Contract/IContractApproval";
import PeriodSelector from "@/components/PeriodSelector.vue";
import DatePeriod from "@/types/DatePeriod";
import DateIgnoreTime from "@/types/DateIgnoreTime";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContractApprovalDownloadPopUp',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "update:downloadToggle", "confirm"],
  setup(__props: any, { emit: __emit }) {

const selectedPeriod = ref();
const ownerFieldInput = ref('')
const props = __props;

const emit = __emit;

const contractsToDownload = computed({
    get() {
        return props.modelValue;
    },
    set(val) { 
        emit('update:modelValue', val); 
        
    }
});

const earliestPeriod = computed(()=>contractsToDownload.value?.reduce
((curDate, x)=>{
    const periodToCompare = x.activationDate ? new DatePeriod(x.activationDate) : undefined;
    if(curDate) {
        return periodToCompare ? periodToCompare < curDate ? periodToCompare : curDate : curDate;
    } else {
        return periodToCompare;
    }
}, undefined as DatePeriod | undefined)
)

function close() {
    contractsToDownload?.value?.forEach(element => {
        element.toDownload = false
    });
    contractsToDownload.value=undefined;
}

const downloading = ref(false)

async function proceedToDownload() {
  if(downloading.value) return
  downloading.value = true;
  const closeSpinner = useSpinnerPopup().show();
  if (!ownerFieldInput.value) {
    useNotifierWithErrFormatter().warn({ msg: 'Owner must be specified' });
  } else {
    
    try {
        const responseData = await fetchData();
        // Change column names
        const remappedData = responseData.map(row => {
            row.issueDate = new DateIgnoreTime(row.issueDate)
            row.activationDate = new DateIgnoreTime(row.activationDate)
            const obj = Object.assign(row, { [`RV ${selectedPeriod.value}`]: row.rvValue, } )
            obj.rvValue = undefined;
            return obj;
        });
        DbTableCsvHelper.generateCsvDownload(remappedData, `EligibleContracts.csv`);
        close()      
    } catch (error) {
      useNotifierWithErrFormatter().error({
        errorType:  'Downloading Eligible Contracts',
    
        error
      });
    }
  }
  closeSpinner();
  downloading.value = false;
}

async function fetchData() {
    if (!contractsToDownload.value) throw new ReferenceError('contractsToDownload is not supposed to be undefined');
    const response = await contractApprovalExport.post({
      owner: ownerFieldInput.value.toString(),
      rvPeriod: selectedPeriod.value,
      contractIDs: contractsToDownload.value.map(x=> x.contractID)
    });
    return response.data;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    "model-value": !!contractsToDownload.value,
    title: "Download Specification",
    hasClose: "",
    "onUpdate:modelValue": close
  }, {
    contents: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ownerFieldInput).value = $event)),
              name: "OwnerField"
            }, null, 512), [
              [_vModelText, ownerFieldInput.value]
            ])
          ]),
          _hoisted_6,
          _createVNode(PeriodSelector, {
            class: "periodSelector",
            defaultRefDate: earliestPeriod.value,
            modelValue: selectedPeriod.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPeriod).value = $event)),
            showTitle: ""
          }, null, 8, ["defaultRefDate", "modelValue"]),
          _hoisted_7,
          _createElementVNode("button", {
            class: "download-btn default-btn right-btn",
            title: 'Approve selected contracts',
            type: "button",
            disabled: downloading.value,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (proceedToDownload()))
          }, " Download ", 8, _hoisted_8)
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})